import { render, staticRenderFns } from "./NirvarLimit.vue?vue&type=template&id=c29844e0&scoped=true&"
import script from "./NirvarLimit.vue?vue&type=script&lang=js&"
export * from "./NirvarLimit.vue?vue&type=script&lang=js&"
import style0 from "./NirvarLimit.vue?vue&type=style&index=0&id=c29844e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c29844e0",
  null
  
)

export default component.exports